import { Outlet, useOutlet } from 'react-router'

import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T } from '@tribeplatform/react-components/i18n'
import { cn } from '@tribeplatform/react-components/utils/cn'
import { useRouter } from '@tribeplatform/react-sdk'
import { BackgroundProvider } from '@tribeplatform/react-ui-kit/BackgroundContext'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { Preview } from '../../Editor/Preview/Preview.js'
import { AnchorComponentProps } from '../../TopNavBar/modes/index.js'

import { CustomizerSidebar } from './CustomizerSidebar.js'

export function CustomizerRootRoute() {
  const outlet = useOutlet()

  return (
    <div className="flex h-full">
      <BackgroundProvider backgroundType="surface">
        <>
          {/* we're doing this for preserving the state of the tree when we navigate to the space route, there is nothing bad with this approach as react in newer version introduces a new Activity Component that do the same with some high level performance improvements: https://react.dev/reference/react/Activity */}
          <div className={cn('h-full', { hidden: !!outlet })}>
            <CustomizerSidebar />
          </div>
          <Outlet />
        </>
      </BackgroundProvider>
      <div className="flex-1 overflow-hidden">
        {outlet ? <Preview /> : <EmptyStateRoute />}
      </div>
    </div>
  )
}

export function CustomizerRootRouteBreadCrumb() {
  const { Link } = useRouter()
  return (
    <Link href={adminRoutes.design.customizer.root}>
      <T id="Generics.Customizer" defaultMessage="Customizer" />
    </Link>
  )
}

function EmptyStateRoute() {
  return (
    <div className="flex-1 flex-col items-center gap-4 pt-20 bg-surface h-full hidden md:flex">
      <SvgIcon name="appearance" size="4x" />
      <div className="flex flex-col items-center gap-2">
        <Text variant="headingMd">
          <T
            id="Admin.Customizer.EmptyStateTitle"
            defaultMessage="Select a page to customize"
          />
        </Text>
        <Text variant="bodySm">
          <T
            id="Admin.Customizer.EmptyStateDescription"
            defaultMessage="Choose a page from the sidebar to customize its layout and content."
          />
        </Text>
      </div>
    </div>
  )
}

export function CustomizerAnchorToDesign(props: AnchorComponentProps) {
  const { Link } = useRouter()

  return <Link href={adminRoutes.site.root} {...props} />
}
